import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { reducer } from './reducer';
import { TextPreview } from './preview';
import { TextForm } from './form';
import { toggleOptional, changeText } from './actions';
import { withSettings } from '../withSettings';
export const mapStateToProps = (state, props) => {
    return {
        ...state[props.componentIdent],
        isChecked: !state[props.componentIdent].isHidden,
    };
};
export const mapDispatchToProps = (dispatch, props) => {
    const componentIdent = props.componentIdent;
    return {
        onChange: (e, eventData) => {
            dispatch(changeText(eventData ? eventData.value : e.target.value, componentIdent));
        },
        onSwitchChange: props.isOptional
            ? (e) => {
                dispatch(toggleOptional(e.target.checked, componentIdent));
            }
            : undefined,
    };
};
export const TextPreviewContainer = compose(withReducer(reducer), connect(mapStateToProps, null))(TextPreview);
export const TextFormContainer = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings(TextForm));
//# sourceMappingURL=container.js.map